import { render, staticRenderFns } from "./statusDetail.vue?vue&type=template&id=161ab52e&scoped=true&"
import script from "./statusDetail.vue?vue&type=script&lang=js&"
export * from "./statusDetail.vue?vue&type=script&lang=js&"
import style0 from "./statusDetail.vue?vue&type=style&index=0&id=161ab52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161ab52e",
  null
  
)

export default component.exports